import React, { useEffect, useRef } from "react";

export default function Cursor() {
  const dot = useRef(null);
  const ring = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(hover: none)").matches) return;
    let x = window.innerWidth / 2, y = window.innerHeight / 2;
    let rx = x, ry = y;
    const move = (e) => { x = e.clientX; y = e.clientY; if (dot.current) { dot.current.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`; } };
    const loop = () => {
      rx += (x - rx) * 0.18;
      ry += (y - ry) * 0.18;
      if (ring.current) ring.current.style.transform = `translate(${rx}px, ${ry}px) translate(-50%, -50%)`;
      requestAnimationFrame(loop);
    };
    const over = (e) => {
      if (!e.target || typeof e.target.closest !== "function") return;
      const t = e.target.closest("a, button, [data-cursor='hover'], input, textarea, select");
      if (ring.current) ring.current.classList.toggle("hover", !!t);
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    const id = requestAnimationFrame(loop);
    return () => { window.removeEventListener("mousemove", move); window.removeEventListener("mouseover", over); cancelAnimationFrame(id); };
  }, []);

  return (
    <>
      <div ref={ring} className="cursor-ring" />
      <div ref={dot} className="cursor-dot" />
    </>
  );
}
